/* eslint-disable */

const marchaBlanca = [] //['04100000597', '137596', '690010907', '07600007080', '07800000035']
const cajaVentanilla = ['caja_ventanilla', '', 'ninguno', 'todos']
const Rules = {
    QuotesPayment: {
        isPaymentsAvailable (policies) {
          for (const policy of policies) {
            const isValidPolicy = (policy.ramo.toLowerCase() === 'vida' && policy.oriProducto !== 'VIDA_CASH_PLUS') || (policy.oriProducto !== null && policy.oriProducto.toLowerCase().includes('vehicular'))
            if (isValidPolicy) {
              return true
            }
          }
          return false
        },
        filterPoliciesPaymentAvailable: (policy) => {
          return (policy.ramo.toLowerCase() === 'vida' && policy.oriProducto !== 'VIDA_CASH_PLUS') || (policy.oriProducto !== null && policy.oriProducto.toLowerCase().includes('vehicular'))
        }
    }
  }
  
  
  export default Rules
  


// WEBPACK FOOTER //
// ./src/interfaces/transactsRestrictions.js